export const MESSAGE = 'message';
export const PRESENCE = 'presence';
export const ROOM = 'groupchat';
export const SUPPORT = 'supportchat';
export const MODERATOR = 'moderator';
export const ADMIN = 'admin';
export const GAME_ROOM_KEY = 'game';
export const SUPPORT_ROOM_KEY = 'support';
